import Model from './model';

export default class TitleCategory extends Model {
  static NAME = 'title_category';
  static COLLECTION_NAME = "title_categories";
  static URL = '/api/v2/title_categories';
}
